import "tailwindcss/tailwind.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/display.css";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import "./views/service/jnpf-flow/assets/scss/common.scss";
import scui from "./scui";
import i18n from "./locales";
import router from "./router";
import { createApp } from "vue";
import store from "./views/service/bpmn/store/index";
import App from "./App.vue";
import {
	default as SylowcodeComponents,
	icons,
	on,
	off,
	trigger,
	onAppInit,
} from "@guizhuan/sylowcode-components";
import "@guizhuan/sylowcode-components/dist/style.css";
import DefaultDataSource from "./datasource/default-service";
import print from "vue3-print-nb";
import gridLayout from "vue-grid-layout";
// erp页面工作插槽容器
import listComponent from "./views/erp/pages/slots/listComponent.vue";
import detailComponent from "./views/erp/pages/slots/detailComponent.vue";
import profileComponent from "./views/erp/pages/slots/profileComponent.vue";
import dialogContainer from "./views/erp/pages/slots/dialogContainer.vue";
import tablePagination from "@/views/erp/pages/components/table-pagination.vue";
import Srarch from '@/views/erp/pages/components/srarch.vue'
//erp功能组件 
import Iframe from '@/views/erp/pages/components/Iframe.vue'

const app = createApp(App);
import http from "./utils/request";

app.use(SylowcodeComponents, {
	datasource: {
		default: DefaultDataSource,
	},
	http,
	router,
});

// 屏蔽console
(function shieldConsole() {
	if (process.env.NODE_ENV == "production"&&window.config.env.urlSite=='GBQ') {
			Reflect.ownKeys(console).map(key => {
					if (typeof console[key] == "function") {
							console[key] = () => {};
					}
			});
	}
	return;
})();

//模块初始化
const loadModel = async () => {
	const installs = import.meta.glob("@/views/**/install.js");
	for (const index in installs) {
		const load = installs[index];
		// console.log(12, load);
		await load().then((r) => {
			r?.default?.install(app, {
				http,
				router,
				icons,
				eventbus: { on, off, trigger, onAppInit },
			});
		});
	}
};
loadModel().then(() => {
	//页面
	const views = import.meta.glob("@/views/**/*.vue");
	app.config.globalProperties.$views = views;
	router.$views = views;

	// const app = createApp(App);
	app.use(store);
	app.use(router);
	app.use(ElementPlus);
	app.use(VXETable);
	app.use(i18n);
	app.use(scui);
	app.use(print);
	app.use(gridLayout);
	app.use(Iframe)
	// app.use(lowcode)
	// 全局组件注册erp插槽
	app.component("listComponent", listComponent);
	app.component("detailComponent", detailComponent);
	app.component("profileComponent", profileComponent);
	app.component("dialogContainer", dialogContainer);
	app.component("tablePagination", tablePagination);
	app.component('Srarch',Srarch)
	app.component('Iframe',Iframe)

	//挂载app
	app.mount("#app");
});
